export default {
  images: (state) => state.images,
  isCrop: (state) => state.isCrop,
  selectedStylesCrop: (state) => state.selectedStylesCrop,
  isCropSaved: (state) => state.isCropSaved,
};
